module.exports = "<table class=month-table> <thead class=month-head> </thead> <tbody class=month-body style=height:100%> </tbody> </table> ";


//////////////////
// WEBPACK FOOTER
// ./app/components/calendar/calendar.main/calendar.month/calendar.month.html
// module id = 4931
// module chunks = 50